import Intro from './Intro';
import Avantages from './Avantages';
import Gamme from './Gamme';
import Partenaire from './Partenaire';
import PartenaireCard from './PartenaireCard';
import Tableau from './Tableau';

export { Intro, Avantages, Gamme, Partenaire, PartenaireCard, Tableau };



// WEBPACK FOOTER //
// ./src/components/Main/brand/index.js